




















import { Vue, Component, Prop } from "vue-property-decorator";

@Component({ components: {} })
export default class CustomButton extends Vue {
  /**
   * !!!
   * Компонент для кастомных кнопок.
   * По умолчанию это стандартная кнопка с дефолтным цветом.
   *
   * Тип кнопки можно изменить через Prop 'type' и ввиде строки передать один из типов. Всего три вида кнопки:
   * 1. active - стандартная
   * 2. passive - белая
   * 3. link - визуальная эмитация ссылки.
   *
   * Кнопка становится неактивной при disable - true (Если надо заблокировать кнопку, например при получении данных);
   *
   */

  @Prop({ default: false }) disable?: boolean;
  @Prop({ default: "active" }) type?: string;
  @Prop({ default: "default" }) size?: string;

  handleClick(event: any) {
    this.$emit("click", event);
  }
}
